<!-- <template>
	<v-layout row>
		<v-flex xs12>
			<v-card>
				<v-card-title class="blue white--text">
					<span class="headline custom-headline">
						<span>M</span><span>e</span><span>i</span><span>n</span><span>B</span><span>u</span><span>b</span><span>u</span><span>.</span><span>d</span><span>e</span>
					</span>
					<v-spacer></v-spacer>

					<v-menu bottom left>
						<template v-slot:activator="{ on }">
							<v-btn dark icon v-on="on">
								<v-icon>more_vert</v-icon>
							</v-btn>
						</template>

						<v-list>
							<v-list-tile v-for="(item, i) in items" :key="i" :to="item.path">
								<v-list-tile-title>{{ item.title }}</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</v-card-title>
			</v-card>
		</v-flex>
	</v-layout>
</template> -->
<template>
	<v-toolbar dark>
		<!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
		<v-toolbar-title class="overflow-vis">
			<v-icon>favorite_border</v-icon>&nbsp;
			<span class="headline custom-headline"> <span>M</span><span>e</span><span>i</span><span>n</span><span>B</span><span>u</span><span>b</span><span>u</span><span>.</span><span>d</span><span>e</span> </span>
		</v-toolbar-title>
		<v-spacer></v-spacer>
		<v-toolbar-items class="hidden-sm-and-down">
			<v-btn v-for="(item, i) in items" :key="i" flat :to="item.path">{{ item.title }}</v-btn>
		</v-toolbar-items>
	</v-toolbar>
</template>
<script>
export default {
	data: () => ({
		items: [{ title: 'Urlaub', path: '/' }]
	})
}
</script>

<style lang="scss">
@import url(https://fonts.googleapis.com/css?family=Finger+Paint);
.overflow-vis {
	overflow: visible;
}
.custom-headline {
	background: transparent;
	overflow: visible;
	font: 5vw/100vh 'Finger Paint';
	text-align: center;
	color: transparent;
	backface-visibility: hidden;
	span {
		display: inline-block;
		text-shadow: 0 0 0 whitesmoke;
		animation: smoky 5s 3s both;
	}

	span:nth-child(even) {
		animation-name: smoky-mirror;
	}

	@keyframes smoky {
		60% {
			text-shadow: 0 0 40px whitesmoke;
		}
		90% {
			transform: translate3d(15rem, -8rem, 0) rotate(-40deg) skewX(70deg) scale(1.5);
			text-shadow: 0 0 20px whitesmoke;
			opacity: 0;
		}
		91% {
			transform: translate3d(0, 0, 0) rotate(0deg) skewX(0deg) scale(1);
			text-shadow: 0 0 40px whitesmoke;
			opacity: 0;
		}
		100% {
			transform: translate3d(0, 0, 0) rotate(0deg) skewX(0deg) scale(1);
			text-shadow: 0 0 0 whitesmoke;
			opacity: 1;
		}
	}

	@keyframes smoky-mirror {
		60% {
			text-shadow: 0 0 40px whitesmoke;
		}
		90% {
			transform: translate3d(18rem, -8rem, 0) rotate(-40deg) skewX(-70deg) scale(2);
			text-shadow: 0 0 20px whitesmoke;
			opacity: 0;
		}
		91% {
			transform: translate3d(0, 0, 0) rotate(0) skewX(0) scale(1);
			text-shadow: 0 0 40px whitesmoke;
			opacity: 0;
		}
		100% {
			transform: translate3d(0, 0, 0) rotate(0) skewX(0) scale(1);
			text-shadow: 0 0 0 whitesmoke;
			opacity: 1;
		}
	}

	@for $item from 1 through 21 {
		span:nth-of-type(#{$item}) {
			animation-delay: #{(3 + ($item/10))}s;
		}
	}
}
</style>
